import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCaretDown, faCaretUp} from "@fortawesome/free-solid-svg-icons";
import {library} from "@fortawesome/fontawesome-svg-core";

library.add(faCaretDown);
library.add(faCaretUp);

const DropdownIndicatorIcon = props => {
    return (
        props.status ? (
            <FontAwesomeIcon icon="caret-up"/>
        ) : (
            <FontAwesomeIcon icon="caret-down"/>
        )
    );
};

export default DropdownIndicatorIcon;